<!--  -->
<template>
  <div class="box">
    <el-container>
      <el-backtop :bottom="10"></el-backtop>
      <el-header style="height:auto;">
        <header-ht></header-ht>
      </el-header>

      <el-main>
        <router-view />
        <footer-ht></footer-ht>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerHt from "../components/header";
import footerHt from "../components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    headerHt,
    footerHt
  },

  data() {
    //这里存放数据
    return {};
  },

  //方法集合
  methods: {}
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类

.el-main {
  padding: 0;
  width: 100%;
  // height: 100%;
}
.el-header {
  padding: 0;
}
</style>
